// TermsOfServicePage.jsx

import React from "react";

const TermsOfServicePage = () => {
  return (
    <div className="container mx-auto mt-8 p-8 text-justify overflow-y-auto">
      <h2 className="text-3xl font-bold lg:text-5xl text-palette1 mb-6">
        Terms of Service
      </h2>

      <div className="text-lg text-palette3 mb-6">
        <p>
          By accessing or using the Dream Innovation Srl website (
          <a href="www.dreaminnovation.it">www.dreaminnovation.it</a>), you agree
          to comply with and be bound by these Terms of Service.
        </p>
      </div>

      <div className="text-lg text-palette3 mb-6">
        <p>
          All content, features, and functionality on the website, including
          but not limited to text, graphics, logos, images, and software, are
          the intellectual property of Dream Innovation Srl and are protected
          by copyright, trademark, and other intellectual property laws.
        </p>
      </div>

    
      <div className="text-lg text-palette3 mb-6">
        <p>
          If you have any questions about these Terms of Service, please contact
          us at info@dreaminnovation.it.
        </p>
      </div>

    </div>
  );
};

export default TermsOfServicePage;
